var Fields;
(function (Fields) {
    Fields["ExecuteActionName"] = "execute";
    Fields["ServiceParam"] = "aws_service";
    Fields["ActionParam"] = "aws_action";
    Fields["RegionParam"] = "aws_region";
    Fields["ArgumentsParam"] = "aws_arguments";
})(Fields || (Fields = {}));
var CoreAwsServiceClient = (function () {
    function CoreAwsServiceClient(service) {
        this.service = service;
    }
    CoreAwsServiceClient.prototype.execute = function (request, decoder) {
        return this.service.callFunction(Fields.ExecuteActionName, [this.getRequestArgs(request)], decoder);
    };
    CoreAwsServiceClient.prototype.getRequestArgs = function (request) {
        var _a;
        var args = (_a = {},
            _a[Fields.ServiceParam] = request.service,
            _a[Fields.ActionParam] = request.action,
            _a[Fields.ArgumentsParam] = request.args,
            _a);
        if (request.region) {
            args[Fields.RegionParam] = request.region;
        }
        return args;
    };
    return CoreAwsServiceClient;
}());
export default CoreAwsServiceClient;
//# sourceMappingURL=CoreAwsServiceClient.js.map